'use client';

import { ReactNode } from 'react';

import { useMaintenance } from '@/hooks/useMaintenance';

import MaintenanceScreen from './MaintenanceScreen';

interface MaintenanceCheckerProps {
  children: ReactNode;
}

export default function MaintenanceChecker({ children }: MaintenanceCheckerProps) {
  const { maintenance, isUnderMaintenance } = useMaintenance();

  // メンテナンス中はメンテナンス画面を表示
  // loading チェックは削除: pollInterval によるポーリング中の loading で
  // 全画面スピナーが表示され子コンポーネントがアンマウントされる問題を防ぐ
  if (isUnderMaintenance && maintenance) {
    return <MaintenanceScreen maintenance={maintenance} />;
  }

  // 通常時は子要素を表示
  return <>{children}</>;
}
